import React from 'react'

import Link from 'next/link'
import {palette} from 'styled-tools'
import styled from 'styled-components'
import {SearchResponse} from '@algolia/client-search'
import Folder6LineIcon from 'remixicon-react/FolderLineIcon'

import {H5, P} from '@festi/common/components/typography'
import {sendSearchClickEvent} from '@festi/common/utils/tagmanager'

import {CategorySuggestions} from 'src/components/search/redesign/utilites/quickSearch'
import {InsightType} from './QuickSearchHits'

const Categories = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

const Category = styled(Link)`
  display: flex;
  gap: 10px;
  padding: 6px;
  border-radius: 8px;

  .remixicon-icon {
    fill: ${palette('ui40Solid')};
  }

  &:hover {
    background-color: ${palette('ui4Solid')};
  }
`

const EmptyResultsText = styled(P)`
  color: ${palette('ui40Solid')};
`

interface HitsProps {
  categoriesResults?: SearchResponse<CategorySuggestions>
  handleClose?: () => void
  handleQuicksearchClickEvents: (
    type: InsightType,
    id: string,
    position: number,
  ) => void
}

export default function CategoryHits({
  categoriesResults,
  handleClose,
  handleQuicksearchClickEvents,
}: HitsProps) {
  const isEmpty = !categoriesResults?.nbHits && !!categoriesResults?.queryID

  return (
    <div>
      <H5 withGutter>Vöruflokkar</H5>

      {isEmpty ? (
        <EmptyResultsText>Engar niðurstöður</EmptyResultsText>
      ) : (
        <Categories>
          {categoriesResults?.hits?.map((hit, index) => (
            <Category
              key={hit.objectID}
              href={`/voruflokkar/${hit.slug}`}
              onClick={() => {
                !!handleClose && handleClose()

                sendSearchClickEvent({
                  search_term: categoriesResults.query,
                  search_type: 'category_suggestion',
                  event_label: hit.name,
                })

                handleQuicksearchClickEvents(
                  InsightType.category,
                  hit.objectID,
                  index + 1,
                )
              }}
            >
              <Folder6LineIcon />
              <P bold>{hit.name}</P>
            </Category>
          ))}
        </Categories>
      )}
    </div>
  )
}
